import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import TableButton from "../../../../../components/element/TableButton";
import { StorageContext } from "../../../../../services/StorageProvider";
import ROUTE_PATHS from "../../../../../utils/routePaths";
import { formatToTwoDecimal } from "../../../../../utils/utils";
import { AIRPORT_FEES_TYPE } from "../../../../../utils/constants";
import "../InvoiceDetail.css";
import Loader from "../../../../../components/element/Loader";
import NoDataPlaceholder from "../../../../../components/element/NoDataPlaceholder";

function InvoiceTable({ invoicesLineItemData, invoiceStatus }) {
  const navigate = useNavigate();
  const { airportData } = useContext(StorageContext);

  const getAirportName = (airportId) => {
    const airport = airportData?.find((airport) => airport?.id === airportId);
    return airport ? airport.name : "Unknown Airport";
  };

  const lineItemsData = invoicesLineItemData?.lineItems || [];

  const getFeeTypeName = (value) => {
    const feeType = AIRPORT_FEES_TYPE.find((fee) => fee.value === value);
    return feeType ? feeType.name : value;
  };

  const handleViewFeeDetails = (lineItem) => {
    navigate(ROUTE_PATHS.COMMERCIAL_AIRLINE_INVOICE_FEE_INVOICE_DETAILS, {
      state: {
        invoiceData: invoicesLineItemData,
        selectedAirlineId: invoicesLineItemData?.airlineId,
        id: invoicesLineItemData?.id,
        invoiceStatus: invoiceStatus,
        lineItem: lineItem,
        feeType: invoicesLineItemData?.feeType,
      },
    });
  };

  const renderContent = () => {
    if (!invoicesLineItemData) return <Loader />;
    if (!invoicesLineItemData.lineItems?.length) return <NoDataPlaceholder />;

    return (
      <TableContainer component={Paper} className="invoices-data-table">
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Airport Name</TableCell>
              <TableCell>{getFeeTypeName(invoicesLineItemData?.feeType) || "Fee"}</TableCell>
              <TableCell>Sub-Total</TableCell>
              <TableCell>VAT (10%)</TableCell>
              <TableCell>Total</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {lineItemsData.map((lineItem, index) => (
              <TableRow key={index} className="table-lineItem">
                <TableCell>{getAirportName(lineItem.airportId)}</TableCell>
                <TableCell>BSD {formatToTwoDecimal(lineItem.fee)}</TableCell>
                <TableCell>{formatToTwoDecimal(lineItem.fee)}</TableCell>
                <TableCell>{formatToTwoDecimal(lineItem.tax)}</TableCell>
                <TableCell>
                  BSD{" "}
                  {formatToTwoDecimal(
                    Number(lineItem.fee) + Number(lineItem.tax)
                  )}
                </TableCell>
                <TableCell>
                  <TableButton onClick={() => handleViewFeeDetails(lineItem)}>
                    View
                  </TableButton>
                </TableCell>
              </TableRow>
            ))}
            <TableRow className="grand-total-invoice">
              <TableCell>
                <Typography variant="h6">Grand Total</Typography>
              </TableCell>
              <TableCell colSpan={3} />
              <TableCell>
                <Typography variant="h6">
                  BSD{" "}
                  {formatToTwoDecimal(
                    lineItemsData.reduce(
                      (sum, item) =>
                        sum + (Number(item.fee) + Number(item.tax)),
                      0
                    )
                  )}
                </Typography>
              </TableCell>
              <TableCell />
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  return renderContent();
}

export default InvoiceTable;
